<mat-tab-group class="booking-details driver" animationDuration="0ms">

  <!--Start Driver Information-->
  <mat-tab label="{{ 'DriverInformation' | translate }}">
    <div class="col-lg-7 col-md-10 p-0">
      <form *ngIf="driverInfoForm!=null" [formGroup]="driverInfoForm" (ngSubmit)="onSubmit()">

        <!--Name-->
        <div class="form-group row">
          <label class="col-12">{{ 'Name' | translate }}</label>
          <div class="col-md-4 pr-lg-0 mb-2 mb-md-1 mb-lg-1">
            <input type="text" placeholder="{{ '1stName' | translate }}" formControlName="firstName"
              class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.firstName.errors }" />
            <div *ngIf="submitted && driverInfo.firstName.errors" class="invalid-feedback">
              <div *ngIf="driverInfo.firstName.errors.required">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 pr-lg-0 mb-2 mb-md-1 mb-lg-1">
            <input type="text" placeholder="{{ '2ndName' | translate }}" formControlName="secondName"
              class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.secondName.errors }" />
            <div *ngIf="submitted && driverInfo.secondName.errors" class="invalid-feedback">
              <div *ngIf="driverInfo.secondName.errors.required">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <input type="text" placeholder="{{ 'FamilyName' | translate }}" formControlName="thirdName"
              class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.thirdName.errors }" />
            <div *ngIf="submitted && driverInfo.thirdName.errors" class="invalid-feedback">
              <div *ngIf="driverInfo.thirdName.errors.required">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Date of Birth-->
        <div class="form-group row">
          <label class="col-12">{{ 'DateofBirth' | translate }}</label>
          <div class="col-md-12">
            <div class="form-date driver-date">
              <mat-form-field appearance="none">
                <mat-datepicker-toggle matPrefix [for]="DateofBirth"></mat-datepicker-toggle>
                <mat-datepicker #DateofBirth></mat-datepicker>
                <input readonly [max]="minDOB" placeholder="" (dateInput)="addEvent(1,'input', $event)"
                  (dateChange)="addEvent(1,'change', $event);"
                  [ngClass]="{ 'is-invalid': submitted && driverInfo.DateofBirth.errors }" formControlName="DateofBirth"
                  matInput [matDatepicker]="DateofBirth" (click)="DateofBirth.open()">

              </mat-form-field>
              <input type="hidden" [ngClass]="{ 'is-invalid': submitted && driverInfo.DateofBirth.errors }" />
              <div *ngIf="submitted && driverInfo.DateofBirth.errors" class="invalid-feedback">
                <div *ngIf="driverInfo.DateofBirth.errors.required">
                  <div class="validation-error">
                    <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!--Email-->
        <div class="form-group row">
          <label class="col-12">{{ 'Email' | translate }}</label>
          <div class="col-md-12">
            <div>{{primaryEmail}}</div>
         <!-- <input type="email" placeholder="email@domain.com" (blur)="emilBlur($event)" formControlName="email"
              class="form-control"
              [ngClass]="{ 'is-invalid': (submitted && driverInfo.email.errors!=null) || (driverInfo.email.errors!=null&&driverInfo.email.errors.exist !=null)}" />

            <div *ngIf="driverInfo.email.errors" class="invalid-feedback">
              <div *ngIf="driverInfo.email.errors.required">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
              <div *ngIf="driverInfo.email.errors.email">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'emailmustbeavalidemailaddressmsg' |
                  translate }}
                </div>
              </div>
              <div *ngIf="driverInfo.email.errors!=null&&driverInfo.email.errors.exist !=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'EmailAlreadyExist' | translate }}
                </div>
              </div>
            </div>  -->


          </div>
        </div>

        <!--Mobile Number-->
        <div class="form-group row" *ngIf="driverInfo!=null">
          <label class="col-12">{{ 'MobileNumber' | translate }}</label>
          <div class="col-md-12">
            <ngx-intl-tel-input [cssClass]="'form-control border-0'" [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
              [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
              [phoneValidation]="true" [separateDialCode]="separateDialCode"
              (countryChange)="mobileNumCountryCodeChanged()" (keydown.space)="$event.preventDefault();"
              [ngClass]="{'is-invalid':submitted && driverInfo.mobileNum.invalid}" name="mobileNum"
              formControlName="mobileNum">
            </ngx-intl-tel-input>
            <div *ngIf=" driverInfo.mobileNum.errors!=null" class="invalid-feedback">
              <div *ngIf="driverInfo.mobileNum.errors.required">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
              <div *ngIf="driverInfo.mobileNum.errors.validatePhoneNumber!=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Invalidphonenumber' | translate }}
                </div>
              </div>
              <div *ngIf="driverInfo.mobileNum.errors.RequiredCountryCode!=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RequiredCountryCode' | translate }}
                </div>
              </div>
              <div *ngIf="driverInfo.mobileNum.errors.InvalidSpace!=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidSpace' | translate }}
                </div>
              </div>
            </div>
          </div>
          <!--
          <div class="col-md-3 pr-0">

            <mat-form-field appearance="none" >
              <mat-select  formControlName="mobileCode" class="form-control mt-0" [ngClass]="{ 'is-invalid': submitted && driverInfo.mobileCode.errors }"
              data-placeholder="Select"
              disableOptionCentering>
                 <mat-option>code</mat-option>
                 <mat-option>079</mat-option>
                 <mat-option>078</mat-option>
                 <mat-option>077</mat-option>
              </mat-select>
            </mat-form-field>

            <div *ngIf="submitted && driverInfo.mobileCode.errors" class="invalid-feedback">
                <div *ngIf="driverInfo.mobileCode.errors.required">{{ 'ThisFiledIsRequired' | translate }}</div>
            </div>
          </div>
          <div class="col-md-9">
            <input type="text" formControlName="mobileNum" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.mobileNum.errors }" />
            <div *ngIf="submitted && driverInfo.mobileNum.errors" class="invalid-feedback">
                <div *ngIf="driverInfo.mobileNum.errors.required">{{ 'ThisFiledIsRequired' | translate }}</div>
            </div>
          </div>

        -->
        </div>

        <!--Start Location -->
        <div class="form-group row">
          <label class="col-12">{{ 'Country' | translate }}</label>
          <div class="col-md-12" *ngIf="locationsRoot!=null">
            <div>

              <mat-select panelClass="select-country" formControlName="country" id="country"
                class="form-control select-control " [(value)]="selectedRoot"
                (selectionChange)="buildLocations($event.value)" name="country"
                [ngClass]="{'is-invalid':driverInfoForm.get('country')!=null&&submitted&&driverInfoForm.get('country').invalid}"
                required>

                <mat-option *ngFor="let location of locationsRoot" [value]="location">
                  {{location.locationName}}
                </mat-option>
              </mat-select>
            </div>

            <!-- <div *ngIf="submitted&&driverInfoForm.get('country')!=null&&driverInfoForm.get('country').invalid" class="invalid-feedback">
              <div class="validation-error">
                <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="driverInfoForm.get('country').errors.required"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
              </div>
            </div> -->


            <div
              *ngIf="submitted && driverInfoForm.get('country')!=null && driverInfoForm.get('country').errors?.required">
              <div class="validation-error">
                <fa-icon class="mr-1" [icon]="faTimesCircle" *ngIf="driverInfoForm.get('country').errors.required">
                </fa-icon>{{ 'ThisFiledIsRequired' | translate }}
              </div>
            </div>







          </div>
        </div>

        <div *ngFor="let item of locationLevelsDropDown" class="form-group row">
          <label class="col-12">{{ item.nameResourceKey | translate }}</label>
          <div class="col-md-12">


            <mat-select panelClass="select-country" class="form-control select-control "
              [(value)]="selectedLevels[item.locationLevelID]" (selectionChange)="getLocationLevelDynamic($event.value)"
              [formControlName]="item.locationLevelID+''"
              [ngClass]="{'is-invalid':submitted&&driverInfoForm.get(item.locationLevelID+'')!=null&&driverInfoForm.get(item.locationLevelID+'').invalid}">

              <mat-option *ngFor="let location of item.locationLevelData" [value]="location">
                {{location.locationName}}
              </mat-option>
            </mat-select>

            <div
              *ngIf="submitted && driverInfoForm.get(item.locationLevelID+'')!=null&&driverInfoForm.get(item.locationLevelID+'').invalid"
              class="invalid-feedback">
              <div class="validation-error">
                <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
              </div>
            </div>





          </div>
        </div>



        <!--END Location-->


        <div class="note-bg mt-3">
          <p>{{ 'AllAdditionalDriversInformationShouldBeDefinedAtPickup' | translate }}</p>
          <p>{{ 'AllInformationRelatedIdentityCard' | translate }}</p>
        </div>

        <div class="text-left mt-50">
          <button class="btn default-btn" mat-button>{{ 'Confirm' | translate }}</button>
          <!-- <h1 *ngIf="saveAndConfirmMsg!=null">{{saveAndConfirmMsg | translate}}</h1> -->
        </div>

        <div class="d-flex post-back-msg mt-3" *ngIf="saveAndConfirmMsg!=null">
          <div class="d-flex justify-content-center align-items-center"><i
              class="fas fa-exclamation-circle mr-2 fa-2x"></i></div>
          <div class="d-flex justify-content-center align-items-center">{{"Sorry" | translate}}! {{saveAndConfirmMsg |
            translate}}.
          </div>
        </div>

      </form>
    </div>

  </mat-tab>
  <!--End Driver Information-->

</mat-tab-group>
